import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {



  const fadeInVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-bronze-600/20 via-silver-600/10 to-gray-800/20"></div>
        <svg className="absolute top-0 left-0 w-full h-full" preserveAspectRatio="none" viewBox="0 0 1200 800">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 pb-6 sm:pb-8">

          {/* Mobile Layout - Stacked */}
          <div className="block md:hidden space-y-8">

            {/* Company Info & CEO - Mobile */}
            <motion.div
              variants={fadeInVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {/* Logo */}
              <div className="flex justify-center mb-6 sm:mb-8">
                <img
                  src="/logo/WithoutBackgroundLogo.png"
                  alt="ARES WOHNBAU Logo"
                  className="h-32 sm:h-40 md:h-48 lg:h-52 w-auto object-contain"
                />
              </div>

              <p className="text-gray-300 mb-4 sm:mb-6 leading-relaxed text-center text-xs sm:text-sm">
                Ihr zuverlässiger Partner für hochwertige Wohnbauprojekte und maßgeschneiderte Projektentwicklung.
              </p>

              {/* CEO Highlight - Mobile */}
              <div className="bg-gradient-to-br from-gray-800/80 to-gray-900/90 backdrop-blur-sm rounded-xl p-4 sm:p-5 border border-bronze-600/30">
                <div className="flex items-center space-x-3 sm:space-x-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-bronze-600 to-bronze-700 rounded-full flex items-center justify-center shadow-lg flex-shrink-0">
                    <span className="text-white text-base sm:text-lg font-semibold">IA</span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-white text-base sm:text-lg font-medium">Esat Arifaj</h4>
                    <p className="text-bronze-400 text-xs sm:text-sm">Geschäftsführer</p>
                    <p className="text-gray-400 text-[10px] sm:text-xs mt-1 sm:mt-2 leading-relaxed">
                      "Qualität und Kundenzufriedenheit stehen bei uns an erster Stelle"
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Navigation & Contact - Mobile Grid */}
            <div className="grid grid-cols-2 gap-6 border-t border-gray-800 pt-8">

              {/* Quick Links - Mobile */}
              <motion.div
                variants={fadeInVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="flex flex-col items-center"
              >
                <h3 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-bronze-400 to-silver-400 mb-4 text-center">Navigation</h3>
                <ul className="space-y-3 w-full">
                  {[
                    { name: 'Services', href: '/services' },
                    { name: 'Über uns', href: '/ueber-uns' },
                    { name: 'Kontakt', href: '/kontakt' }
                  ].map((link) => (
                    <li key={link.name} className="w-full">
                      <Link
                        to={link.href}
                        className="text-gray-300 hover:text-bronze-400 transition-colors duration-300 group flex items-center justify-center text-sm py-1"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-bronze-600 mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>

              {/* Contact - Mobile */}
              <motion.div
                variants={fadeInVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
                className="flex flex-col items-center"
              >
                <h3 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-bronze-400 to-silver-400 mb-4 text-center">Kontakt</h3>

                <div className="space-y-4 w-full">
                  <div className="text-center bg-gray-800/30 rounded-xl p-3 border border-gray-700/30">
                    <div className="w-8 h-8 bg-gradient-to-br from-bronze-600/20 to-bronze-700/30 rounded-lg flex items-center justify-center mx-auto mb-2 shadow-md">
                      <svg className="w-4 h-4 text-bronze-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <p className="text-white text-xs font-medium">+49 15123080311</p>
                  </div>

                  <div className="text-center bg-gray-800/30 rounded-xl p-3 border border-gray-700/30">
                    <div className="w-8 h-8 bg-gradient-to-br from-silver-600/20 to-silver-700/30 rounded-lg flex items-center justify-center mx-auto mb-2">
                      <svg className="w-4 h-4 text-silver-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <p className="text-white text-[10px] break-all font-medium">info@ares-wohnbau.de</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          {/* Desktop Layout - Grid */}
          <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">

            {/* Company Info & CEO - Desktop */}
            <motion.div
              className="col-span-2"
              variants={fadeInVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {/* Logo */}
              <div className="mb-8">
                <img
                  src="/logo/WithoutBackgroundLogo.png"
                  alt="ARES WOHNBAU Logo"
                  className="h-48 sm:h-52 md:h-56 lg:h-60 xl:h-64 w-auto object-contain"
                />
              </div>

              <p className="text-gray-300 mb-6 leading-relaxed text-base">
                Ihr zuverlässiger Partner für hochwertige Wohnbauprojekte und maßgeschneiderte Projektentwicklung.
                Wir verwirklichen Ihre Wohnträume mit modernster Technologie und jahrelanger Erfahrung.
              </p>

              {/* CEO Highlight - Desktop */}
              <div className="bg-gradient-to-br from-gray-800/80 to-gray-900/90 backdrop-blur-sm rounded-2xl p-6 border border-bronze-600/30 shadow-xl">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-bronze-600 to-bronze-700 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white text-lg font-semibold">IA</span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-white text-lg font-medium">Esat Arifaj</h4>
                    <p className="text-bronze-400 text-base">Geschäftsführer</p>
                    <p className="text-gray-400 text-sm mt-1 leading-relaxed">
                      "Qualität und Kundenzufriedenheit stehen bei uns an erster Stelle"
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Quick Links - Desktop */}
            <motion.div
              variants={fadeInVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <h3 className="text-xl text-white mb-6">Navigation</h3>
              <ul className="space-y-3">
                {[
                  { name: 'Home', href: '/' },
                  { name: 'Über uns', href: '/ueber-uns' },
                  { name: 'Services', href: '/services' },
                  { name: 'Kontakt', href: '/kontakt' }
                ].map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-300 hover:text-primary transition-colors duration-300 group flex items-center text-base"
                    >
                      <svg className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Contact - Desktop */}
            <motion.div
              variants={fadeInVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <h3 className="text-xl text-white mb-6">Kontakt</h3>

              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-300 text-sm">Telefon</p>
                    <p className="text-white text-base">+49 15123080311</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-300 text-sm">E-Mail</p>
                    <p className="text-white text-base break-all">info@ares-wohnbau.de</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
            <div className="flex flex-col lg:flex-row items-center justify-between space-y-3 lg:space-y-0">

              {/* Copyright */}
              <div className="text-gray-400 text-xs sm:text-sm text-center lg:text-left">
                © {currentYear} Ares Wohnbau. Alle Rechte vorbehalten.
              </div>

              {/* Legal Links */}
              <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6">
                <Link to="/impressum" className="text-gray-400 hover:text-primary text-xs sm:text-sm transition-colors duration-300">
                  Impressum
                </Link>
                <Link to="/datenschutz" className="text-gray-400 hover:text-primary text-xs sm:text-sm transition-colors duration-300">
                  Datenschutz
                </Link>
                <Link to="/agb" className="text-gray-400 hover:text-primary text-xs sm:text-sm transition-colors duration-300">
                  AGB
                </Link>
                <Link to="/cookies" className="text-gray-400 hover:text-primary text-xs sm:text-sm transition-colors duration-300">
                  Cookies
                </Link>
              </div>

              {/* Social Links */}
              <div className="flex items-center space-x-3 sm:space-x-4">
                <a
                  href="https://facebook.com/areswohnbau"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 group"
                  aria-label="Facebook"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>

                <a
                  href="https://instagram.com/areswohnbau"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 group"
                  aria-label="Instagram"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.987 11.987c6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.648.001 12.017.001zM8.449 16.988c-1.297 0-2.349-1.051-2.349-2.349c0-1.297 1.051-2.349 2.349-2.349c1.297 0 2.349 1.051 2.349 2.349C10.798 15.936 9.747 16.988 8.449 16.988z" />
                  </svg>
                </a>

                <a
                  href="https://linkedin.com/company/areswohnbau"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 group"
                  aria-label="LinkedIn"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

